<template>
    <div id="idClientTerrestreForm" class="w-100 text-center">
        <loading v-if="showLoadingClienteGroundForm" />

        <div v-else class="w-100">
            <table class="table table-bordered ">
                <thead>
                    <tr class="bg-secondary">
                        <th nowrap v-for="(header,index) in headers" :key="index"> {{ header }} </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(val,index) in data" :key="index">
                        <td>
                            {{ (index + 1) }}
                        </td>
                        <td>
                            {{ val.id }}
                        </td>

                        <td>

                            <ui-select
                                class="w-100"
                                has-search
                                placeholder="Seleccionar"
                                searchPlaceholder="Buscar"
                                :options="[]"
                                v-model="val.id_client"
                                :keys="selectFormat"
                                :disabled="true"
                            />
                        </td>

                        <td>
                            <ui-select
                                class="w-100"
                                has-search
                                placeholder="Seleccionar"
                                searchPlaceholder="Buscar"
                                :options="listCarriers"
                                v-model="val.id_carrier"
                                :keys="selectFormat"
                                :disabled="true"
                            />
                        </td>

                        <td>
                            <date-picker
                                placeholder="Fecha"
                                type="date"
                                class="w-100"
                                value-type="format"
                                v-model="val.from"
                                :disabled="true"
                            />
                        </td>
                        <td>
                            <date-picker
                                placeholder="Fecha"
                                type="date"
                                class="w-100"
                                value-type="format"
                                v-model="val.to"
                                :disabled="true"
                            />
                        </td>
                        <td>        
                            <ui-select
                                class="w-100"
                                has-search
                                placeholder       = "Seleccionar"
                                searchPlaceholder = "Buscar"
                                :options          = "[]"
                                v-model           = "val.id_pol"
                                :keys             = "selectFormat"
                                disabled
                            /> 
                        </td>
                        <td>        

                            <ui-select
                                class="w-100"
                                has-search
                                placeholder       = "Seleccionar"
                                searchPlaceholder = "Buscar"
                                :options          = "[]"
                                v-model           = "val.plant_id"
                                :keys             = "selectFormat"
                                disabled
                            /> 
                        </td>

                        <td>        
                            <ui-select
                                class="w-100"
                                has-search
                                placeholder       = "Seleccionar"
                                searchPlaceholder = "Buscar"
                                :options          = "[]"
                                v-model           = "val.id_pod"
                                :keys             = "selectFormat"
                                disabled
                            /> 
                        </td>
                       
                        <td>
                            <ui-select
                                class="w-100"
                                has-search
                                placeholder="Seleccionar"
                                searchPlaceholder="Buscar"
                                :options="groundTariffsExtraCostType"
                                v-model="val.id_type_extra_cost"
                                :keys="selectFormat"
                                disabled
                            />
                        </td>

                        <td>
                            <ui-select
                                class="w-100"
                                has-search
                                placeholder="Seleccionar"
                                searchPlaceholder="Buscar"
                                :options="containerTypes"
                                v-model="val.id_type_container"
                                :keys="selectFormat"
                                disabled
                            />
                        </td>

                        <td>
                            <ui-select
                                class="w-100"
                                has-search
                                placeholder="Seleccionar"
                                searchPlaceholder="Buscar"
                                :options="listCurrencies"
                                v-model="val.id_currency"
                                :keys="selectFormat"
                                disabled
                            />
                        </td>
                        <td>
                            <input 
                                type="text" 
                                class="text_field_mask"
                                v-mask="weightMask"
                                v-model="val.value"
                            />
                        </td>
                        <td>
                            <ui-textbox
                                class="w-100"
                                floating-label
                                placeholder="Observaciones..."
                                v-model="val.comment"
                            />
                        </td>
                    </tr> 
                </tbody>
            </table>

            <Button
                text="Editar"
                :width="120"
                :height="40"
                class="float-right"
                color="#21831b"
                colorText="#fff"
                icon="far fa-paper-plane"
                title="Crear"
                horizontal
                @click.native="!btnAction && update()"
                :inactive="btnAction"

            />

        </div>
        
    </div>
    
</template>

<script >
import DatePicker from "vue2-datepicker";

import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { mapActions, mapState } from 'vuex';
import Button from '../../../common/Button.vue';
import Loading from '../../../common/loading.vue';
import { tariffClientsGroundFind, tariffClientsGroundIndex, tariffClientsGroundUpdate } from "../../../../constants/serviciosLogisticos";

const weightMask = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: true,
  requireDecimal: false,
  includeThousandsSeparator: false,
  decimalSymbol: ".",
  decimalLimit: 2,
  integerLimit: 9

});

export default {

    data() {
        return {
            data : [  ],
            weightMask,
            selectFormat : { value: 'id', label: 'name' },
            headers: [ "N°", "ID" ,"Cliente" ,"Proveedor","Desde", "Hasta", "Retiro/Entrega (Vacío)","Planta/Bodega", "Entrega/Retiro (Full)", "Extra Costo Tipo", "Tipo Contenedor","Moneda", "Valor", "Observaciones"],
            btnAction : false,
            showBtnEdit : false ,

        };
    },
    props: {
        closeModal : { type: Function, default: () => {} },
        ids  : { type: Array, default: () => [] },
        idDuplicate : { type: Array, default: () => [] },
    },

    components: { 
        DatePicker , 
        Button, 
        Loading ,
    },

    mounted() {},
    
    computed: {
        ...mapState("serviciosLogisticos", [
            "listCarriers",
            "listCurrencies",
            "extraCostTypes",
            "unityPayments",
            "containerTypes",
            "showLoadingClienteGroundForm",
            "groundTariffsExtraCostType"
        ])
    },
    methods: {

        ...mapActions("serviciosLogisticos", [
            "actionSetDataTableClientGround",
            "actionSetShowLoadingClientGround",
            "actionSetShowLoadingClienteGroundForm",
            "actionSetDataTableClienteExtraCosto"
        ]),

        createPayload(){
            return this.data.map( r => ({
                id              : r.id ?? null ,
                value           : r.value ,
                comment         : r.comment == "" ? null : r.comment ,
            }));
        },

        validate(){

            for ( const index in this.data ) {

                const element = this.data[ index ];

                if( ! element.value ){
                    this.$vToastify.warning("Campo 'Valor' requerido.", "Alerta Item N° " + (index+ 1));
                    return false ;
                }
            }
            return true ;
        } ,

        async update(){

            if( ! this.validate() ) return ;

            this.btnAction = true ;
            const payload = this.createPayload();

            this.$vToastify.loader("Actualizando...");

            try {
                
                await tariffClientsGroundUpdate( payload ) ;

                this.$vToastify.stopLoader();

                this.$vToastify.success("Se han actualizado Tarifa Cliente Correctamente", "Éxito");
                
                this.rechargeTable() ;

                this.btnAction = false ;
                return this.closeModal() ;

            } catch (error) {

                this.$vToastify.stopLoader();
                this.btnAction = false ;

                return this.$vToastify.error("Hubo un error al actualizar, recargue la pagina y vuelva a intentar.", "Error" );
            }
           
        },
        async rechargeTable(){
              
            this.actionSetShowLoadingClientGround( true );

            const { data } = await tariffClientsGroundIndex() ;

            this.actionSetDataTableClientGround( data ) ;

            this.actionSetShowLoadingClientGround( false );

        },
        async setData( ids ){

            this.actionSetShowLoadingClienteGroundForm( true );

            const { data } = await tariffClientsGroundFind({ ids }) ;

            this.data = data.map( d => ({
                id : d.id ?? null ,
                id_client : {
                    id: d.id_client ,
                    name : d.name_client
                },
                id_carrier : {
                    id: d.ground_provider_id ,
                    name : d.name_carrier
                },
                from : d.from ,
                to   : d.to ,

                id_pol : {
                    id: d.pol_id ,
                    name : d.name_pol
                },

                plant_id : {
                    id: d.plant_id ,
                    name : d.name_plant
                },
                id_pod : {
                    id: d.id_pod ,
                    name : d.name_pod
                },
                id_zone : {
                    id: d.id_zone ,
                    name : d.name_zone
                },

                id_type_extra_cost : {
                    id: d.id_extra_cost_type ,
                    name : d.name_extra_cost_type
                },
                id_type_container : {
                    id: d.container_type_id ,
                    name : d.name_type_container
                },
                id_currency : {
                    id: d.currency_id ,
                    name : d.name_format_currency
                },
                value : d.value ,
                comment : d.comment 
            }));

            this.actionSetShowLoadingClienteGroundForm( false );
        }
    },



     watch : {
            ids : function( _new ){

                if( _new.length > 0 ){
                    this.setData( _new ) ;
                } 
            },
            idDuplicate : function( _new ){
                if( _new.length > 0 ) this.setData( _new , true ) ;
            },
            
    },

    directives: {},

    filters: {}
};
</script>

<style >

#idClientTerrestreForm .mx-input {
    padding-left: 2px !important;
    border-radius: 0 !important;
    border: none !important;
    border-bottom: 1px solid #dcdcdc !important;
    box-shadow: none !important;
}

#idClientTerrestreForm .text_field_mask {
  background: none;
  border: none;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-radius: 0;
  color: rgba(0, 0, 0, 0.87);
  cursor: auto;
  display: block;
  font-family: inherit;
  font-size: 1rem;
  font-weight: normal;
  margin: 0;
  outline: none;
  padding: 0;
  transition: border 0.1s ease;
  width: 100%;
  height: 32px;
}
</style>